module.exports = __webpack_public_path__ + "img/terroir-charcoal-4-mobile.548210dc.jpg";